import { Box, Button, Text } from "@chakra-ui/react";
import PlaidConnect from "components/elements/PlaidConnect";
import { AlertsContext } from "providers/alerts";
import { LoanContext } from "providers/loan";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useContext, useState } from "react";
import { apiRequest } from "utils/api";
import { getErrorMessage } from "utils/errorHandler";
import { numberToDollar } from "utils/helpers";
import { useLoanActions } from "providers/loans/mutations/loan-actions";

const FundsRequested = () => {
  const { user } = useTenant();
  const { loan } = useContext(LoanContext);
  const { showError, showSuccess } = useContext(AlertsContext);
  const [verifying, setVerifying] = useState(false);

  const { applyChanges } = useLoanActions();

  async function verifyFunds() {
    try {
      setVerifying(true);

      const { bank_accounts } = await apiRequest("/supabase/bank_accounts/select");

      const available_balances = bank_accounts.reduce(
        (acc: any, cur: any) => acc + cur.available_balance,
        0
      );

      if (loan!.funds_requested > available_balances) {
        showError({
          title: "Funds Not Verified",
          description:
            "There are not enough funds in your available balance. You can try refreshing your balances.",
        });
      } else {
        await apiRequest("/supabase/events/insert", {
          name: "verified_funds",
          loanId: loan!.id,
          data: {
            amount: loan!.funds_requested,
          },
        });

        await applyChanges.mutateAsync({
          id: loan!.id,
          funds_verified: true,
        });

        showSuccess({
          title: "Funds Verified",
        });
      }
    } catch (err) {
      showError({
        description: getErrorMessage(err),
      });
    } finally {
      setVerifying(false);
    }
  }

  return (
    <Box>
      <Text mb="16px" fontSize="13px" lineHeight="24px">
        The lender has requested proof of funds for this loan.
      </Text>
      <Text mb="0px" fontSize="14px" fontWeight="500" color="#222222">
        Requested Amount
      </Text>
      <Text mb="10px" fontSize="20px" fontWeight="600">
        {numberToDollar(loan!.funds_requested)}
      </Text>

      <PlaidConnect />

      {user.plaid_tokens.length > 0 && (
        <Button isLoading={verifying} w="100%" onClick={verifyFunds} mt="12px">
          Submit Proof of Funds
        </Button>
      )}
    </Box>
  );
};

export default FundsRequested;
